import styled from 'styled-components';
import { differenceInDays } from 'date-fns';

export const hasUserCancelledPWA = PWAInfo =>
  PWAInfo.canceledAt && differenceInDays(new Date(), new Date(PWAInfo.canceledAt)) < 3 + PWAInfo.cancelCount * 3;

export const isInStandaloneMode = () =>
  (window && window.navigator && window.navigator.standalone) ||
  (window && window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
  (window && window.navigator && window.navigator.standalone);

export const isIPhone = () => /iPhone/i.test(navigator.userAgent);

export const isIPad = () => /iPad/i.test(navigator.userAgent);

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const isSafari = () => !!navigator.userAgent.match(/Version\/[\d]+.*Safari/);

export const isAndroidDevice = () => /Android/i.test(navigator.userAgent);

export const isApplicableMobileDevice = () => isIOS() || isAndroidDevice();

export const Box = styled.div`
  background-color: ${p => p.theme.button.default.backgroundColor.string()};
  padding: 0.75em 1.25em;
`;

export const AppIcon = styled.img`
  border: 2px solid ${p => p.theme.button.primary.backgroundColor.string()};
  border-radius: 12px;
  box-sizing: content-box;
  height: 32px;
  padding: 1.25rem 0.5rem;
  box-shadow: ${p => p.theme.button.primary.backgroundColor.string()} 0 0.1rem 0.75rem;
  background-color: ${p => p.theme.colors.dark.string()};
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  h3 {
    font-size: 1.1em;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 0.5em;
    line-height: 1.2em;
  }
  img {
    height: 14px;
    margin-left: 2px;
  }
  ${p => (p.darker ? `color: ${p.theme.colors.primary.darken(0.18).string()};` : '')}
`;

export const Line = styled.div`
  background-color: ${p => p.theme.colors.primary.darken(0.18).string()};
  margin-bottom: 1rem;
  width: 100%;
  height: 1px;
`;
